import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../lib/sessionClient";
import { clearLocalStorageSession } from "../../lib/authUtils";

const useCheckData = (method, apiEndPoint) => {
  const navigate = useNavigate();
  const [confirmDialogBox, setConfirmDialogBox] = useState(false);
  const [buttonStatus, setButtonStatus] = useState();
  const [bodyData, setBodyData] = useState({});
  const [isActionSucceed, setIsActionSucceed] = useState(false);
  const [checkResponseData, setCheckResponseData] = useState([]);
  const [checkLoading, setCheckLoading] = useState(false);
  const [checkedErr, setCheckedErr] = useState("");

  const handleCheck = async () => {
    setCheckLoading(true);
    try {
      const response = await api({
        method: method,
        url: apiEndPoint,
        data: bodyData,
      });

      setCheckResponseData(response.data);
      setIsActionSucceed(true);
      setConfirmDialogBox(false);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        clearLocalStorageSession();
        navigate("/login");
      } else {
        setConfirmDialogBox(false);
        setCheckedErr(error.response?.data?.message || error.message);
      }
    } finally {
      setCheckLoading(false);
    }
  };
  return {
    confirmDialogBox,
    setConfirmDialogBox,
    setBodyData,
    isActionSucceed,
    setIsActionSucceed,
    buttonStatus,
    setButtonStatus,
    handleCheck,
    checkResponseData,
    checkedErr,
    setCheckedErr,
    checkLoading,
    bodyData,
  };
};

export default useCheckData;
